import React, { useEffect, useState } from "react";
import { managerAxios } from "../../axiosInstance";
import loader from "../../assets/loader.webp";
import EditProfile from "./EditProfile";
import AccountBoxIcon from "@mui/icons-material/AccountBox";
import EditReceiptTemplate from "./EditReceiptTemplate";
import CategoryIcon from "@mui/icons-material/Category";
import { fetchOnlyData } from "../../utility/managerApi";
import { useQuery } from "@tanstack/react-query";

function Profile() {
  const [viewModal, setViewModal] = useState(false);
  const [editTab, setEditTab] = useState(false);
  const [profileData, setProfileData] = useState();
  const [isLoading, setIsLoading] = useState(true);

  const { data: template, error } = useQuery({
    queryKey: ["admintemplate"],
    keepPreviousData: true,
    queryFn: () => fetchOnlyData("receipt-template"),
    staleTime: Infinity,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    retry: false,
  });

  const fetchData = async () => {
    try {
      const response = await managerAxios.get("/users/profile");
      setProfileData(response?.data?.data);
    } catch (err) {
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  if (isLoading) {
    return (
      <div className="w-full h-screen  flex justify-center items-center">
        <img src={loader} alt="loader" className=" w-10 lg:w-20 " />
      </div>
    );
  }
  return (
    <div className="lg:overflow-y-hidden ">
      {/* Header */}
      <div className="flex flex-col lg:flex-row justify-between mb-6 items-center w-full border-b-2 pb-2">
        <h3 className="text-xl font-semibold">Profile</h3>
        <div className="flex gap-6">
          <button
            onClick={() => setEditTab(true)}
            className="p-4 rounded-lg text-white bg-green-500"
          >
            Edit Profile
          </button>
        </div>
      </div>

      {editTab && (
        <EditProfile
          singleData={profileData}
          setEdittab={setEditTab}
          fetchProfile={fetchData}
          setIsLoading={setIsLoading}
          setSingleData={setProfileData}
        />
      )}

      {!editTab && (
        <div className="flex flex-col">
          <div className="flex justify-between items-center">
            <div className="flex gap-3 flex-col">
              <div className="flex gap-4 flex-row">
                <h3>First Name:</h3>
                <h4 className="text-base">{profileData?.firstname}</h4>
              </div>

              <div className="flex gap-3 flex-row">
                <h3>Last Name:</h3>
                <h4 className="text-base">{profileData?.lastname}</h4>
              </div>
              <div className="flex gap-3 flex-row">
                <h3>Email:</h3>
                <h4 className="text-base">{profileData?.email}</h4>
              </div>
              <div className="flex gap-3 flex-row">
                <h3>Address:</h3>
                <h4 className="text-base">{profileData?.address}</h4>
              </div>
              <div className="flex gap-3 flex-row">
                <h3>Phone Number: </h3>
                <h4 className="text-base">{profileData?.phoneno}</h4>
              </div>
            </div>
            <div>
              {profileData?.image == !null ? (
                <img src={profileData.image} />
              ) : (
                <AccountBoxIcon sx={{ fontSize: "250px", color: "grey" }} />
              )}
            </div>
          </div>

          <button
            onClick={() => setViewModal(true)}
            className="flex flex-row gap-2  p-2 items-center"
          >
            <CategoryIcon />
            <span className="text-lg font-medium hidden lg:block">
              Edit Receipt template
            </span>
          </button>
        </div>
      )}
      {viewModal && (
        <EditReceiptTemplate template={template} setViewModal={setViewModal} />
      )}
    </div>
  );
}

export default Profile;
